import React, { useState, useEffect } from "react";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TextField, Checkbox, Autocomplete, Button, Chip } from "@mui/material";
import { useApiContext } from "../../../../Utils/ApiContext/ApiContext";
import { Snackbar, Alert } from "@mui/material";
import ApiServices from "../../../../Utils/ApiServices/ApiServices";
import { getDecryptedAccessToken, getDecryptedData } from "../../../../Utils/LoginUserDetails.js/LoginUserSavedDetails";
import { useParams } from "react-router-dom";


const AppointmentExercises = ({data,appointmentData}) => {
  const { exercises, fetchData } = useApiContext();
  const [filteredExercises, setFilteredExercises] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedExercises, setSelectedExercises] = useState([]);
    const [selectedPrimaryMuscles, setSelectedPrimaryMuscles] = useState([]);
    const [selectedSecondaryMuscles, setSelectedSecondaryMuscles] = useState([]);
    const [selectedEquipment, setSelectedEquipment] = useState([]);
    const [primaryMuscleOptions, setPrimaryMuscleOptions] = useState([]);
    const [secondaryMuscleOptions, setSecondaryMuscleOptions] = useState([]);
    const [equipmentOptions, setEquipmentOptions] = useState([]);
    const [selectedExercisesData, setSelectedExercisesData] = useState([]);
    const daysOfWeek = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
    const [exerciseDays, setExerciseDays] = useState({});
    const params= useParams()
  const pid = params.pid || appointmentData?.pc_pid;

const [startDate, setStartDate] = useState("");
const [endDate, setEndDate] = useState("");
const [isAssigning, setIsAssigning] = useState(false);
const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
const accessToken = getDecryptedAccessToken()
const LoginUserData = getDecryptedData()
const [assignedExercises,setAssignedExercises] = useState([])
  useEffect(() => {
    fetchData("/apis/default/api/exercises");
    setFilteredExercises(exercises);
    extractFilterOptions(exercises);
    ApiServices.get(`/apis/default/api/patient/exercises/${pid}`,{
         Authorization: `Bearer ${accessToken}`
    })
    .then((response)=>{
        setAssignedExercises(response.data)
    })
  }, [exercises,pid]);

  const extractFilterOptions = (data) => {
    const primaryMusclesSet = new Set();
    const secondaryMusclesSet = new Set();
    const equipmentSet = new Set();
    
    data.forEach((exercise) => {
      exercise.primary_muscles.replace(/"/g, "").split(", ").forEach(muscle => primaryMusclesSet.add(muscle));
      exercise.secondary_muscles.replace(/"/g, "").split(", ").forEach(muscle => secondaryMusclesSet.add(muscle));
      equipmentSet.add(exercise.equipment.replace(/"/g, ""));
    });

    setPrimaryMuscleOptions(Array.from(primaryMusclesSet));
    setSecondaryMuscleOptions(Array.from(secondaryMusclesSet));
    setEquipmentOptions(Array.from(equipmentSet));
  };

  const applyFilters = (search, primaryMuscles, secondaryMuscles, equipment) => {
    let filtered = exercises;

    if (search) {
      filtered = filtered.filter(ex => 
        ex.exercise_name.toLowerCase().includes(search.toLowerCase())
      );
    }

    if (primaryMuscles.length > 0) {
      filtered = filtered.filter(ex =>
        primaryMuscles.some(muscle => ex.primary_muscles.includes(muscle))
      );
    }

    if (secondaryMuscles.length > 0) {
      filtered = filtered.filter(ex =>
        secondaryMuscles.some(muscle => ex.secondary_muscles.includes(muscle))
      );
    }

    if (equipment.length > 0) {
      filtered = filtered.filter(ex => equipment.includes(ex.equipment));
    }

    setFilteredExercises(filtered);
  };
  const handleSelectExercise = (exercise) => {
    setSelectedExercises((prev) =>
      prev.some((ex) => ex.id === exercise.id)
        ? prev.filter((ex) => ex.id !== exercise.id)
        : [...prev, exercise]
    );
  
    setSelectedExercisesData((prev) =>
      prev.some((ex) => ex.exercise_id === exercise.id)
        ? prev.filter((ex) => ex.exercise_id !== exercise.id)
        : [...prev, { exercise_id: exercise.id, sets: 3, repeats: 12 }]
    );
  };
  const handleExerciseChange = (exerciseId, field, value) => {
    setSelectedExercisesData((prev) =>
      prev.map((ex) =>
        ex.exercise_id === exerciseId ? { ...ex, [field]: value } : ex
      )
    );
  };


  const handleDaysChange = (exerciseId, newDays) => {
    setExerciseDays((prev) => ({ ...prev, [exerciseId]: newDays }));
  };

  const handleAssignExercises = async () => {
    if (!startDate || !endDate) {
      setSnackbar({ open: true, message: "Please select start and end date.", severity: "warning" });
      return;
    }

    setIsAssigning(true);
    try {
      const exerciseSchedule = daysOfWeek
        .map((day) => ({
          day,
          exercises: selectedExercisesData
            .filter((ex) => exerciseDays[ex.exercise_id]?.includes(day))
            .map((ex) => ({ ...ex, start_date: startDate, end_date: endDate })),
        }))
        .filter((entry) => entry.exercises.length > 0);

      const payload = {
        patient_id: params.pid,
        assigned_by: LoginUserData.id,
        exercise_schedule: exerciseSchedule,
      };

      await ApiServices.post("/apis/default/api/patient/exercises", payload, {
        Authorization: `Bearer ${accessToken}`,
      });

      setSnackbar({ open: true, message: "Exercises assigned successfully!", severity: "success" });
      setSelectedExercises([]);
      setSelectedExercisesData([]);
      setExerciseDays({});
      setStartDate("");
      setEndDate("");
    } catch (error) {
      setSnackbar({ open: true, message: "Failed to assign exercises!", severity: "error" });
    } finally {
      setIsAssigning(false);
    }
  };


  return (
    <div>
      {/* Filters */}
      <div style={{ display: "flex", gap: "10px", marginBottom: "10px" }}>
         <TextField
                  label="Search Exercise"
                  variant="outlined"
                  size="small"
                  value={searchQuery}
                  onChange={(e) => {
                    setSearchQuery(e.target.value);
                    applyFilters(e.target.value, selectedPrimaryMuscles, selectedSecondaryMuscles, selectedEquipment);
                  }}
                  fullWidth
                />
       <Autocomplete
                 multiple
                 options={primaryMuscleOptions}
                 getOptionLabel={(option) => option}
                 value={selectedPrimaryMuscles}
                 onChange={(e, newValue) => {
                   setSelectedPrimaryMuscles(newValue);
                   applyFilters(searchQuery, newValue, selectedSecondaryMuscles, selectedEquipment);
                 }}
                 renderInput={(params) => <TextField {...params} label="Primary Muscles" variant="outlined" size="small" />}
                 fullWidth
               />
               <Autocomplete
                 multiple
                 options={secondaryMuscleOptions}
                 getOptionLabel={(option) => option}
                 value={selectedSecondaryMuscles}
                 onChange={(e, newValue) => {
                   setSelectedSecondaryMuscles(newValue);
                   applyFilters(searchQuery, selectedPrimaryMuscles, newValue, selectedEquipment);
                 }}
                 renderInput={(params) => <TextField {...params} label="Secondary Muscles" variant="outlined" size="small" />}
                 fullWidth
               />
               <Autocomplete
                 multiple
                 options={equipmentOptions}
                 getOptionLabel={(option) => option}
                 value={selectedEquipment}
                 onChange={(e, newValue) => {
                   setSelectedEquipment(newValue);
                   applyFilters(searchQuery, selectedPrimaryMuscles, selectedSecondaryMuscles, newValue);
                 }}
                 renderInput={(params) => <TextField {...params} label="Equipment" variant="outlined" size="small" />}
                 fullWidth
               />
      </div>

      {/* Exercises Table (Smaller Height) */}
      <TableContainer component={Paper} sx={{ maxHeight: 250, overflowY: "auto" }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell></TableCell>
              <TableCell><b>Name</b></TableCell>
              <TableCell><b>Primary Muscles</b></TableCell>
              <TableCell><b>Secondary Muscles</b></TableCell>
              <TableCell><b>Equipment</b></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredExercises.map((exercise) => (
              <TableRow key={exercise.id}>
                <TableCell>
                  <Checkbox
                    checked={selectedExercises.some((ex) => ex.id === exercise.id)}
                    onChange={() => handleSelectExercise(exercise)}
                  />
                </TableCell>
                <TableCell>{exercise.exercise_name}</TableCell>
                <TableCell>{exercise.primary_muscles.replace(/"/g, "")}</TableCell>
                                <TableCell>{exercise.secondary_muscles.replace(/"/g, "")}</TableCell>
                <TableCell>{exercise.equipment.replace(/"/g, "")}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {selectedExercises.length > 0 && (
  <div style={{ marginTop: "10px" }}>
    <h4>Selected Exercises:</h4>
    <TableContainer component={Paper} sx={{ maxHeight: 250, overflowY: "auto" }}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell><b>Name</b></TableCell>
            <TableCell><b>GIF</b></TableCell>
            <TableCell><b>Sets</b></TableCell>
            <TableCell><b>Repeats</b></TableCell>
            <TableCell><b>Days</b></TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
        {selectedExercises.map((ex) => {
              const exData = selectedExercisesData.find((e) => e.exercise_id === ex.id) || { sets: 3, repeats: 12 };
              return (
                <TableRow key={ex.id}>
                  <TableCell>{ex.exercise_name}</TableCell>
                  <TableCell><img src={ex.gif_url} alt={ex.exercise_name} width="50" height="50" /></TableCell>
                  <TableCell>
                    <TextField
                      type="number"
                      size="small"
                      value={exData.sets}
                      onChange={(e) => handleExerciseChange(ex.id, "sets", Number(e.target.value))}
                      inputProps={{ min: 1 }}
                      sx={{ width: 60 }}
                    />
                  </TableCell>
                  <TableCell>
                    <TextField
                      type="number"
                      size="small"
                      value={exData.repeats}
                      onChange={(e) => handleExerciseChange(ex.id, "repeats", Number(e.target.value))}
                      inputProps={{ min: 1 }}
                      sx={{ width: 60 }}
                    />
                  </TableCell>
                  <TableCell>
                    <Autocomplete
                      multiple
                      options={daysOfWeek}
                      value={exerciseDays[ex.id] || []}
                      onChange={(_, newValue) => handleDaysChange(ex.id, newValue)}
                      renderTags={(value, getTagProps) =>
                        value.map((option, index) => (
                          <Chip variant="outlined" label={option} {...getTagProps({ index })} />
                        ))
                      }
                      renderInput={(params) => <TextField {...params} variant="outlined" size="small" placeholder="Days" />}
                    />
                  </TableCell>
                  <TableCell>
                    <Button size="small" color="error" onClick={() => setSelectedExercises(selectedExercises.filter(e => e.id !== ex.id))}>
                      Remove
                    </Button>
                  </TableCell>
                </TableRow>
              );
            })}
        </TableBody>
      </Table>
    </TableContainer>

    {/* Start & End Date Selection */}
    <div style={{ marginTop: "10px", display: "flex", gap: "10px" }}>
      <TextField
        label="Start Date"
        type="date"
        InputLabelProps={{ shrink: true }}
        value={startDate}
        onChange={(e) => setStartDate(e.target.value)}
        // inputProps={{ min: new Date().toISOString().split("T")[0] }}
      />
      <TextField
        label="End Date"
        type="date"
        InputLabelProps={{ shrink: true }}
        value={endDate}
        onChange={(e) => setEndDate(e.target.value)}
        inputProps={{ min: startDate }}
      />
    </div>

    {/* Assign Button */}
    <Button
      variant="contained"
      color="primary"
      onClick={handleAssignExercises}
      disabled={isAssigning}
      sx={{ marginTop: "10px" }}
    >
      {isAssigning ? "Assigning..." : "Assign Exercises"}
    </Button>
  </div>
)}

<Snackbar
  open={snackbar.open}
  autoHideDuration={3000}
  onClose={() => setSnackbar({ ...snackbar, open: false })}
>
  <Alert severity={snackbar.severity} onClose={() => setSnackbar({ ...snackbar, open: false })}>
    {snackbar.message}
  </Alert>
</Snackbar>

    </div>
  );
};

export default AppointmentExercises;
